import { z } from 'zod';

import { Direction } from './primitives';

export const TickerItem = z.object({
  sym: z.string().min(1),
  px: z.string(),
  chg: z.string(),
  dir: Direction,
});

export const NavLink = z.object({
  href: z.string().startsWith('/'),
  label: z.string(),
});

export const FooterLink = z.object({
  label: z.string(),
  href: z.string(),
});

export const FooterColumn = z.object({
  heading: z.string(),
  links: z.array(FooterLink).min(1),
});

export const StatusBarItem = z.object({
  label: z.string(),
  value: z.string(),
  kind: z.enum(['indicator', 'metric']).default('metric'),
});

export const SiteSchema = z.object({
  brand: z.object({
    name: z.string(),
    tagline: z.string(),
    mark: z.string().length(1),
    legalName: z.string(),
    offices: z.array(z.string()),
    email: z.string().email().optional(),
  }),
  compliance: z.object({
    chips: z.array(z.string()),
    disclaimer: z.string().min(100),
  }),
  ticker: z.array(TickerItem).min(8),
  nav: z.array(NavLink).min(1),
  footer: z.object({
    columns: z.array(FooterColumn).min(2),
  }),
  statusBar: z.array(StatusBarItem).optional(),
});

export type Site = z.infer<typeof SiteSchema>;
export type TickerItem = z.infer<typeof TickerItem>;
export type NavLink = z.infer<typeof NavLink>;
export type FooterColumn = z.infer<typeof FooterColumn>;
